import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import * as Cookies from "es-cookie";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import AssignmentHome from "../components/_assignment/AssignmentHome"

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
          educationalClasses {
            id
            class
          }
        classes{
            id
            class
        }
        exams{
            id
            exam
            exam_subjects{
                subject_id
              }
        }
          globalBranches{
            id
            branch_name
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
          }
          globalPackages {
            id
            package_name
            exams_covered
          }
          globalCategories {
            id
            category_name
            package_id
          }
          offlineExamSubjects{
            id
            subject
          }
    }
}

`;

class Assignment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        // const getNewEducationalStudents = this.props.getNewEducationalStudents;
        // const loading2 = getNewEducationalStudents.loading;
        // const error2 = getNewEducationalStudents.error
        // console.log("getNewEducationalStudents", getNewEducationalStudents);

        // if (error2 !== undefined) {
        //     alert("Server Error. " + error2.message);
        //     return null;
        // }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
                        <Container fluid>
                            {
                                loading1 ?
                                    (
                                        <Container>
                                            <Row className="my-2">
                                                <Col>
                                                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    ) :
                                    (
                                        // <AssignmentHome
                                        //     globals={globals.globals}
                                           
                                        // />

                                        <>
                                    {
                                        (() => {
                                            let globalsData = globals.globals;

                                            if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                                                let globalBranches = [];

                                                globalsData.globalBranches.map((item) => {
                                                    if (Cookies.get("branch_id") == item.id) {
                                                        globalBranches.push(item)
                                                    }
                                                });

                                                globalsData.globalBranches = globalBranches

                                            }
                                            console.log("globalsData", globalsData);

                                            return (
                                                <>

                                                    <AssignmentHome
                                                        globals={globalsData}
                                                       
                                                    />
                                                </>
                                            );
                                        })()
                                    }
                                </>
                                    )
                            }

                        </Container>

                    </div>
                    <Footer />
                </div>
            </div>
        );

    }
}

export default withRouter(compose(
    graphql(FETCH_GLOBALS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }), 
)(Assignment));

//  export default Assignment;